import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import SaveIcon from '@mui/icons-material/Save'
import SaveAsIcon from '@mui/icons-material/SaveAs'

import { DataGrid, esES } from '@mui/x-data-grid'

const Goals = (props) => {
  const { firestore } = useFirebase()
  const {
    addDocToCollection,
    deleteDocFromCollection,
    updateDocFromCollection,
    getGoals, 
    goals,
    getVirtues,
    virtues,
  } = firestore

  const [loading, setLoading] = useState(false)

  const [rows, setRows] = useState([])

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'name', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nombre'}</b>
      ),
      renderCell: (params) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <b>{params.value}</b>
        </span>
      ),
      minWidth: 300,
      flex: 0,
    },
    { 
      field: 'description', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Descripción'}</b>
      ), 
      minWidth: 300,
      flex: 2,
    },
    { 
      field: 'virtue', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Virtud'}</b>
      ), 
      minWidth: 120,
      flex: 1,
    },
    // { 
    //   field: 'guia', 
    //   headerName: 'Guía', 
    //   width: 130, 
    //   renderCell: (params) => {
    //     return <Button component='a' href={params.value} target='_blank' disabled={params.value === ''} variant='contained' disableElevation size='small'>{params.value === '' ? 'No disponible' : 'Ver'}</Button>
    //   }
    // },
  ]

  useEffect(() => {
    getGoals()
    getVirtues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (goals === undefined) return

    var data = []

    goals.forEach(async (goal) => {
      if (goal.endDate === undefined) {
        console.log(goal)
      }

      if (goal.preceptorId !== 'admin') return
      data.push({
        'id': goal['id'],
        'name': goal['name'],
        'description': goal['description'],
        'virtue': goal['virtue']['name'],
        'virtueId': goal['virtue']['id']
      })
    })
    setRows(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goals])

  const [name, setName] = useState('')
  const handleNameChanged = (event) => {
    setName(event.target.value)
  }

  const [description, setDescription] = useState('')
  const handleDescriptionChanged = (event) => {
    setDescription(event.target.value)
  }

  const [selectionModel, setSelectionModel] = useState([])

  const handleRowClick = (event) => {
    const id = event.id
    const row = event.row
    if (selectionModel.includes(id)) {
      clear()
    } else {
      setName(row.name)
      setDescription(row.description)
      setVirtue(virtues.filter(virtue => virtue.id === row.virtueId)[0])
    }
  }

  const [virtue, setVirtue] = useState('')
  const handleVirtueChange = (event) => {
    setVirtue(event.target.value)
  }

  const clear = () => {
    setSelectionModel([])
    setName('')
    setDescription('')
    setVirtue('')
  }

  const onCreateOrEdit = async () => {
    setLoading(true)
    
    const data = {
      'name': name,
      'description': description,
      'preceptorId': 'admin',
      'schoolId': 'admin',
      'studentId': 'admin',
      'status': 'Asignada',
      'endDate': new Date(),
      'virtue': {
        'id': virtue.id,
        'name': virtue.name
      }
    }

    if (selectionModel.length === 0) {
      await addDocToCollection('goals', data)
    } else {
      const id = selectionModel[0]
      await updateDocFromCollection('goals', id, data)
    }

    clear()
    setLoading(false)
  }

  const onDelete = async () => {
    const id = selectionModel[0]
    await deleteDocFromCollection('goals', id)
    clear()
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>Metas</b>
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1' gutterBottom>
                  <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITAR' : 'NUEVA'} META</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={name}
                  onChange={handleNameChanged}
                  placeholder='Nombre de la meta'
                  // label='Nombre'
                  // InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={description}
                  onChange={handleDescriptionChanged}
                  placeholder='Describe la meta'
                  // label='Descripción'
                  // InputLabelProps={{ shrink: true }}
                  multiline
                  maxRows={6}
                  fullWidth
                />
              </Grid>
              {
                virtues !== undefined ? (
                  <Grid item xs={12}>
                    <FormControl fullWidth variant='outlined'>
                      <InputLabel shrink id='select-outlined-virtue'>Virtud</InputLabel>
                      <Select
                        displayEmpty
                        labelId='select-outlined-virtue'
                        id='select-outlined-virtue'
                        onChange={handleVirtueChange}
                        value={virtue}
                        label='Virtud'
                        notched
                      >
                        <MenuItem disabled value=''>
                          <em>Seleccionar</em>
                        </MenuItem>
                        { 
                          virtues.map((virtue, index) =>
                            <MenuItem key={`virtue_${index}`} value={virtue}>
                              {virtue.name}
                            </MenuItem>
                          )
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                ) : null
              }
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: 'end', p: 0, pt: 2 }}>
            {
              selectionModel.length > 0 ? (
                <Button color='warningRed' disableElevation variant='contained' onClick={onDelete} sx={{ mr: 'auto' }}>
                  <b style={{ fontWeight: 900 }}>BORRAR</b>
                </Button>
              ) : null
            }
            {
              name !== '' || description !== '' ? (
                <Button color='secondary' disableElevation variant='contained' onClick={clear}>
                  <b style={{ fontWeight: 900 }}>CANCELAR</b>
                </Button>
              ) : null
            }
            <LoadingButton disabled={ name === '' || description === '' || virtue === '' } color='primary' disableElevation variant='contained' onClick={onCreateOrEdit} loading={loading} loadingPosition='start' startIcon={loading ? <SaveAsIcon /> : <SaveIcon />}>
              {
                loading ? <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITANDO' : 'CREANDO'}</b> : <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITAR' : 'CREAR'}</b>
              }
            </LoadingButton>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={12} md={6} lg={8}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>LISTA DE METAS</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  autoHeight
                  rowHeight={200}
                  getRowHeight={() => 'auto'} 
                  // getEstimatedRowHeight={() => 400}
                  // disableColumnMenu
                  columns={columns}
                  localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  pageSize={10}
                  rows={rows}
                  rowsPerPageOptions={[10]}
                  onRowClick={handleRowClick}
                  onSelectionModelChange={setSelectionModel}
                  selectionModel={selectionModel}
                  sx={{
                    borderWidth: 0,
                    '& .MuiDataGrid-cell': {
                      py: 2,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default Goals